import { Block } from '@fluentsms/agentnet-web-icons';
import { useTheme } from '@material-ui/core';
import React from 'react';

export const TemplateBlock = (): JSX.Element => {
  const theme = useTheme();

  return <Block height="auto" width="16" data-testid="custom-template-block-icon" fill={theme.palette?.primary.main} />;
};
